function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "placeholder (1)");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Telas-Incendio-Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Emiss\\xE3o-Full-Page",
  transform: "translate(-326.000000, -298.000000)",
  fill: "#FF6414",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(289.000000, 252.000000)"
}, React.createElement("g", {
  id: "placeholder-(1)",
  transform: "translate(37.000000, 46.000000)"
}, React.createElement("path", {
  d: "M11.3807052,2.04751969 L11.3807052,2.04751969 C8.77740281,-0.682506563 4.55629729,-0.682506563 1.95262814,2.04751969 L1.95262814,2.04751969 C-0.393204767,4.50754334 -0.657276013,9.13951096 1.33352778,11.9229993 L6.66666667,20 L11.9998056,11.9229993 C13.9906093,9.13951096 13.7265381,4.50754334 11.3807052,2.04751969 Z M6.66666667,9.47368421 C5.43925926,9.47368421 4.44444444,8.41342105 4.44444444,7.10526316 C4.44444444,5.79710526 5.43925926,4.73684211 6.66666667,4.73684211 C7.89407407,4.73684211 8.88888889,5.79710526 8.88888889,7.10526316 C8.88888889,8.41342105 7.8937037,9.47368421 6.66666667,9.47368421 Z",
  id: "Shape"
})))));

var SvgWaypoint = function SvgWaypoint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWaypoint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waypoint.af30ddf1.svg";
export { ForwardRef as ReactComponent };